import Header from './Header';
import Button from '../component/Button';
import { Link, useNavigate,useParams } from 'react-router-dom';
import { wrapComponent } from 'react-snackbar-alert';
import { useState } from 'react';
import { loginWithOtp, Post,VerifyOtpURL } from '../utils/api';
import {useDispatch} from 'react-redux';

const LoginOtp = ({createSnackbar}) => {
    const inputRef = {

    }
    const params = useParams();
    const [otp1,setotp1] = useState('');
    const [otp2,setotp2] = useState('');
    const [otp3,setotp3] = useState('');
    const [otp4,setotp4] = useState('');
    const [otp5,setotp5] = useState('');
    const [otp6,setotp6] = useState('');
    
    const navigate = useNavigate();
    
    const showSnack = (msg='') =>{
        createSnackbar({
            message: msg,
            theme: 'error',
        });
    }

    const verifyOtp = () =>{
        global.Loader(true)
        let config = {
            body:{input:params?.mobile,otp:`${otp1}${otp2}${otp3}${otp4}${otp5}${otp6}`},
            url:VerifyOtpURL
        }
        Post(config).then((res)=>{
            global.Loader(false)
            if(res.status == true) {
                if(params?.type == 'forget') {
                    navigate(`/updatepassword`);
                } else {
                    global.dispatch({type:'LOGIN',payload:{token:res?.access_token,data:res?.data}});
                    navigate(`/home`);
                }
            }
            else {
                showSnack(res?.message || res?.msg);
            }
        }).catch((err)=>{
            global.Loader(false)

            console.log(err);
        })
    }

    const sendOtp = () =>{
        global.Loader(true)
        let config = {
            body:{input:params?.mobile},
            url:loginWithOtp
        }
        Post(config).then((res)=>{
            global.Loader(false)
            if(res.status == true) {
                showSnack(res?.message);
            }
            else {
                showSnack(res?.message);
            }
        }).catch((err)=>{
            global.Loader(false)

            console.log(err);
        })
    }

    const goBackInput = (e,key) =>{
        if((e.code == 'Backspace' || e.code == 'Delete') && e.target.value == '') {
            inputRef[`input${key}`]?.focus();
        }
    }
    return (
        <div className="best">
            <Header />
            <div className="bredcrub">
            <div className="container">
                <ul>
                    <li><a href="#">Home</a></li> <i className="fa-solid fa-angle-right"></i>
                    <li><a href="#">Register</a></li>
                </ul>
            </div>
        </div>

        <div className="otpbox">
            <h2>Verify your<br/>
                phone number</h2>
            <p>Please find a six-digit OTP that we have sent<br/>on your mobile number and enter it below.</p>

            <form action="" className="mt-2 mb-2">
                <input onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                        }
                    }} ref={ref=>inputRef['input1']=ref} className="otp" style={{marginRight:5}} type="text" onChange={({target})=>{
                    setotp1(target.value)
                    if(target.value != '') inputRef['input2']?.focus();
                }} maxlength="1" />
                <input onKeyDown={(e)=>goBackInput(e,1)} onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                        }
                    }} ref={ref=>inputRef['input2']=ref} className="otp" style={{marginRight:5}} type="text" onChange={({target})=>{
                    setotp2(target.value)
                    if(target.value != '') inputRef['input3']?.focus();
                }} maxlength="1" />
                <input onKeyDown={(e)=>goBackInput(e,2)} onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                        }
                    }} ref={ref=>inputRef['input3']=ref} className="otp" style={{marginRight:5}} type="text" onChange={({target})=>{
                    setotp3(target.value)
                    if(target.value != '') inputRef['input4']?.focus();
                }} maxlength="1" />
                <input onKeyDown={(e)=>goBackInput(e,3)} onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                        }
                    }} ref={ref=>inputRef['input4']=ref} className="otp" style={{marginRight:5}} type="text" onChange={({target})=>{
                    setotp4(target.value)
                    if(target.value != '') inputRef['input5']?.focus();
                }} maxlength="1" />
                <input onKeyDown={(e)=>goBackInput(e,4)} onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                        }
                    }} ref={ref=>inputRef['input5']=ref} className="otp" style={{marginRight:5}} type="text" onChange={({target})=>{
                    setotp5(target.value)
                    if(target.value != '') inputRef['input6']?.focus();
                }} maxlength="1" />
                <input  onKeyDown={(e)=>goBackInput(e,5)} onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                        }
                    }} ref={ref=>inputRef['input6']=ref} className="otp" style={{marginRight:5}} type="text" onChange={({target})=>{
                    setotp6(target.value)
                }} maxlength="1" />
            </form>
            <div>
                <Button onClick={verifyOtp}  style={{width:'20%',marginBottom:20}} disable={(`${otp1}${otp2}${otp3}${otp4}${otp5}${otp6}`?.length != 6)} title={'Submit'} />
            </div>

            <p className="otpbottominfo"><a href="">Skip I'll Verify later</a></p>
            <p className="otpbottominfo">Did not recive an OTP?<br/><span style={{textDecoration:'underline'}} onClick={sendOtp}>Resend OTP</span> or <Link to={'/'}>try another
                    number</Link></p>
        </div>
        </div>
    );
};
  
export default wrapComponent(LoginOtp);